
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M19.5 11.5v11a1 1 0 01-1 1h-17a1 1 0 01-1-1v-19a1 1 0 011-1h13"}}),_c('path',{staticClass:"a",attrs:{"d":"M12.824 14.007l-4.949 2.12 2.121-4.95L20.674.5l2.828 2.828-10.678 10.679zM21.667 5.164l-2.829-2.829M12.824 14.007l-2.828-2.83"}})])
          )
        }
      }
    